import React from "react";
import { MapPin, Clock, Home, Users, PackageCheck, Truck } from "lucide-react";
import { useLang } from "@/context/LangContext";

export const SheinSpotlight = ({ onApply }) => {
  const { t } = useLang();
  const tasks = t("shein.tasks");
  return (
    <section id="shein" data-testid="shein-vacancy-spotlight" className="relative py-16 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="bg-[#E63946]/10 text-[#E63946] border border-[#E63946]/30 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider">
              {t("shein.featured")}
            </span>
            <h2 className="font-head font-extrabold text-3xl md:text-5xl mt-5 leading-tight text-[#0B132B]">
              {t("shein.titlePre")}<span className="bg-[#0B132B] text-white px-2 rounded">SHEIN</span>{t("shein.titlePost")}
            </h2>
            <div className="ej-accent-bar mt-5" />

            <div className="flex flex-wrap gap-5 mt-6 text-slate-600 text-sm">
              <span className="flex items-center gap-2"><MapPin size={16} className="text-[#E63946]" /> {t("shein.loc")} 🇵🇱</span>
              <span className="flex items-center gap-2"><Clock size={16} className="text-[#E63946]" /> {t("shein.shifts")}</span>
              <span className="flex items-center gap-2"><Users size={16} className="text-[#E63946]" /> {t("shein.people")}</span>
            </div>

            <p className="text-slate-600 mt-6">{t("shein.desc")}</p>

            <div className="grid grid-cols-2 gap-3 mt-6">
              {tasks.map((tk) => (
                <div key={tk} className="flex items-center gap-2 text-sm text-slate-700 bg-[#F5F7FB] rounded-lg px-3 py-2.5 border border-slate-200">
                  <PackageCheck size={16} className="text-[#16a34a] shrink-0" /> {tk}
                </div>
              ))}
            </div>

            <button
              onClick={onApply}
              data-testid="shein-apply-btn"
              className="mt-8 bg-[#FFD166] text-[#0B132B] font-bold px-8 py-4 rounded-full hover:bg-[#E0A926] transition-colors"
            >
              {t("shein.cta")}
            </button>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="bg-[#0B132B] rounded-2xl border border-white/10 p-6 col-span-2">
              <div className="text-sm text-slate-400">{t("shein.salary")}</div>
              <div className="text-4xl font-head font-extrabold text-[#FFD166] mt-1">25 PLN<span className="text-lg text-slate-300"> {t("shein.perHour")}</span></div>
              <div className="text-sm text-slate-300 mt-1">{t("shein.equiv")}</div>
            </div>
            <div className="bg-[#1C2541] rounded-2xl border border-white/10 p-6 flex flex-col items-start">
              <Home className="text-[#FFD166]" />
              <div className="font-semibold mt-3 text-white">{t("shein.housing")}</div>
              <div className="text-xs text-slate-400 mt-1">{t("shein.housingSub")}</div>
            </div>
            <div className="bg-[#1C2541] rounded-2xl border border-white/10 p-6 flex flex-col items-start">
              <Truck className="text-[#FFD166]" />
              <div className="font-semibold mt-3 text-white">{t("shein.flight")}</div>
              <div className="text-xs text-slate-400 mt-1">{t("shein.flightSub")}</div>
            </div>
            <img
              src="https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&q=85&w=940"
              alt="Centro logístico moderno en Polonia"
              className="col-span-2 rounded-2xl border border-slate-200 h-48 w-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
